import { render, staticRenderFns } from "./CobrancasExtras.vue?vue&type=template&id=aa66eebc&scoped=true"
import script from "./CobrancasExtras.vue?vue&type=script&lang=js"
export * from "./CobrancasExtras.vue?vue&type=script&lang=js"
import style0 from "./CobrancasExtras.vue?vue&type=style&index=0&id=aa66eebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa66eebc",
  null
  
)

export default component.exports